import { Row, Col, Button } from "react-bootstrap";
import { BiUpArrow } from "react-icons/bi"; // Assuming BiUpArrow is the equivalent of KeyboardArrowUpIcon
import { BsPerson, BsCart, BsWallet, BsCashStack } from "react-icons/bs"; // Assuming these are equivalent icons
import "./widget.css";
const Widget = ({ type }) => {
  let data;

  //temporary
  const amount = 100;
  const diff = 20;

  switch (type) {
    case "user":
      data = {
        title: "USERS",
        isMoney: false,
        // link: "See all users",
        icon: <BsPerson className="icon" />,
        color: "crimson",
        bgColor: "rgba(255, 0, 0, 0.2)",
      };
      break;
    case "order":
      data = {
        title: "ORDERS",
        isMoney: false,
        link: "View all orders",
        icon: <BsCart className="icon" />,
        color: "goldenrod",
        bgColor: "rgba(218, 165, 32, 0.2)",
      };
      break;
    case "earning":
      data = {
        title: "EARNINGS",
        isMoney: true,
        link: "View net earnings",
        icon: <BsCashStack className="icon" />,
        color: "green",
        bgColor: "rgba(0, 128, 0, 0.2)",
      };
      break;
    case "balance":
      data = {
        title: "BALANCE",
        isMoney: true,
        link: "See details",
        icon: <BsWallet className="icon" />,
        color: "purple",
        bgColor: "rgba(128, 0, 128, 0.2)",
      };
      break;
    default:
      break;
  }

  return (
    <div className="widget">
      <Row>
        <Col xs={7} className="left">
          <span className="title">{data.title}</span>
          <span className="counter">
            {data.isMoney && "$"} {amount}
          </span>
          <Button variant="link" className="link">
            {data.link}
          </Button>
        </Col>
        <Col xs={5} className="right">
          <div className={`percentage ${diff > 0 ? "positive" : "negative"}`}>
            <BiUpArrow /> {Math.abs(diff)} %
          </div>
          <div
            className="icon-container"
            style={{ backgroundColor: data.bgColor }}
          >
            {data.icon}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Widget;
